import {apiClientEnabledFeatureRequests} from '#/repository/api-client-enabled-feature-requests';
import {useQuery} from '@tanstack/react-query';

export const useClientEnabledFeatures = () =>
  useQuery({
    queryKey: ['client-enabled-features'],
    queryFn: () => apiClientEnabledFeatureRequests.get(),
  });
